import { missionStatuses } from '../../../../backend/extraTypes';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { z } from 'zod';
export const missionEntityName = 'missions';
export const internalMissionTypeNameChangeSchema = z.object({
    missionTypeName: z.string().trim().min(1),
});
export const missionStatusSchema = z.enum(missionStatuses);
export const missionSchema = z.object({
    name: z.string().trim().min(1),
    typeId: z.string().uuid(),
    description: z.string().optional(),
    contactName: z.string().trim().min(1),
    contactEmail: z.string().optional(),
    contactPhone: z.string().optional(),
    status: missionStatusSchema.optional(),
    internalMissionChange: z.boolean().optional(),
    promotedAt: z.number().optional(),
    organizationSharing: z.union([z.literal('public'), z.string().uuid().array()]).optional(),
    internalMissionTypeNameChange: internalMissionTypeNameChangeSchema.optional(),
});
export const missionColumns = defineColumns({
    search: {
        type: 'full-text-search-required',
        language: 'english',
    },
    name: {
        type: 'string-required',
        index: true,
    },
    typeId: {
        type: 'string-required',
        index: true,
    },
    type: {
        type: 'string-required',
        index: true,
    },
    status: {
        type: 'string-required',
        index: true,
    },
    createdAt: {
        type: 'number-required',
        index: true,
    },
    promotedAt: {
        type: 'number',
    },
    public: {
        type: 'boolean',
        index: false,
    },
    organizationSharing: {
        type: 'id-array-required',
        index: true,
    },
});
